import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

export const getSalesInvoiceCheckSlip = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_check_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const updateCheckSlipStatus = async (id, status) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_check_payments/record_action",
      {
        requester: getUser(),
        token: getToken(),
        sales_invoice_check_slip_id: id,
        action: status,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const createSalesInvoiceCheckPayment = async (data, items) => {
  try {
    const formData = new FormData()
    data.attachments.map((file) => {
      formData.append(`attachments[]`, file)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("customer_id", data.customer_id)
    formData.append("bank_name", data.bank_name)
    formData.append("check_no", data.check_no)
    formData.append("check_date", data.check_date)
    formData.append("issued_date", data.issued_date)
    formData.append("payee", data.payee)
    formData.append("particulars", data.particulars ? data.particulars : "")
    formData.append("acknowledged_by", data.acknowledged_by)
    formData.append("commission", data.commission ? data.commission : 0.0)
    // formData.append("total_sales", data.total_sales);
    // formData.append("vat_sales", data.vat_sales);
    // formData.append("vat", data.vat);
    // formData.append("withholding_tax", data.withholding_tax);
    // formData.append("wht_percentage", data.wht_percentage);
    // formData.append("grand_total", data.grand_total);

    formData.append("withholding_tax_total", data.withholding_tax_total)
    formData.append("total_amount", data.total_amount)
    formData.append("subtotal", data.subtotal)
    formData.append("total_others", data.total_others)
    formData.append("grand_total", data.grand_total)

    items.map((item) => {
      formData.append(`sales_invoice_ids[]`, item.sales_invoice_id)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_check_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateSalesInvoiceCheckPayment = async (data, items) => {
  try {
    const formData = new FormData()
    data.attachments.map((file, index) => {
      formData.append(`attachments[]`, file)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("sales_invoice_check_slip_id", data.id)
    formData.append("customer_id", data.customer_id)
    formData.append("bank_name", data.bank_name)
    formData.append("check_no", data.check_no)
    formData.append("check_date", data.check_date)
    formData.append("issued_date", data.issued_date)
    formData.append("payee", data.payee)
    formData.append("particulars", data.particulars ? data.particulars : "")
    formData.append("acknowledged_by", data.acknowledged_by)
    formData.append("commission", data.commission ? data.commission : 0.0)
    // formData.append("total_sales", data.total_sales);
    // formData.append("vat_sales", data.vat_sales);
    // formData.append("vat", data.vat);
    // formData.append("withholding_tax", data.withholding_tax);
    // formData.append("wht_percentage", data.wht_percentage);
    // formData.append("grand_total", data.grand_total);

    formData.append("withholding_tax_total", data.withholding_tax_total)
    formData.append("total_amount", data.total_amount)
    formData.append("subtotal", data.subtotal)
    formData.append("total_others", data.total_others)
    formData.append("grand_total", data.grand_total)

    items.map((item) => {
      formData.append(`sales_invoice_ids[]`, item.sales_invoice_id)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_check_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteSalesInvoiceCheckPayment = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      sales_invoice_check_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_check_payments/delete_slip",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
